<template>
<div class="page-container-content tabgroup">
  <!-- <w-objtype-bar></w-objtype-bar> -->
  <w-tool-tabs v-model="activeTabName">
    <div v-show="activeTabName === tabs.performance.name" slot="tool">
      <el-radio-group v-model="perfViewType" class="customised-radio">
        <el-radio-button label="list" class="list">
          <el-tooltip>
            <img src="@/assets/img/icons/list_hover.png">
            <!-- <i class="fas fa-list" /> -->
            <span slot="content">리스트</span>
          </el-tooltip>
        </el-radio-button>
        <el-radio-button label="heatmap">
          <el-tooltip>
            <img src="@/assets/img/icons/heatmap_hover.png">
            <!-- <i class="fas fa-th-large" /> -->
            <span slot="content">히트맵</span>
          </el-tooltip>
        </el-radio-button>
      </el-radio-group>
      <span></span>
      <span></span>
    </div>
    <el-tab-pane :label="tabs.performance.label" :name="tabs.performance.name">
      <div class="full-wrapper">
        <el-scrollbar :ref="`${tabs.performance.name}-scrollbar`">
          <div class="full">
            <w-objtype-bar v-if="treeType == 'logical' || isPhysicalManagetypeNode" :active="tabs.performance.active" :is-physical-managetype-node="isPhysicalManagetypeNode"></w-objtype-bar>
            <w-perf-info-group :active="tabs.performance.active" :perf-view-type="perfViewType"></w-perf-info-group>
          </div>
        </el-scrollbar>
      </div>
    </el-tab-pane>
    <el-tab-pane :label="tabs.config.label" :name="tabs.config.name">
      <div class="full-wrapper">
        <el-scrollbar :ref="`${tabs.config.name}-scrollbar`">
          <div class="full">
            <w-objtype-bar v-if="treeType == 'logical' || isPhysicalManagetypeNode" :active="tabs.config.active" :is-physical-managetype-node="isPhysicalManagetypeNode"></w-objtype-bar>
            <w-config-group :active="tabs.config.active"></w-config-group>
          </div>
        </el-scrollbar>
      </div>
    </el-tab-pane>
  </w-tool-tabs>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEqual, isNil } from 'lodash';
import { MANAGETYPE_OBJDEFINE } from '@/constants/objdefine';
import { performanceGroupTabs } from '@/constants/performance';
import RouterTab from '@/mixins/router/tab';
import ScrollbarMixin from '@/mixins/scrollbar';
import WConfigGroup from '@/views/config/group/';
import WObjtypeBar from './components/ObjtypeBar';
import WPerfInfoGroup from './perfinfo/';

export default {
  name: 'WPerformanceGroup',
  components: {
    WObjtypeBar,
    WConfigGroup,
    WPerfInfoGroup,
  },
  mixins: [RouterTab, ScrollbarMixin],
  data() {
    return {
      perfViewType: 'list',
      tabs: performanceGroupTabs,
      // activeTab: 'perfgroup',
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
    isPhysicalManagetypeNode() {
      const treeKey = this.selectedNode.treeKey;
      if (isEqual(this.treeType, 'physical') && !isNil(treeKey) && treeKey.split('.').length === 2) {
        return true;
      }
      return false;
    },
  },
  watch: {
    activeTab: {
      handler(to) {
        if (to) {
          this.scrollbarRef = `${to.name}-scrollbar`;
          this.setScrollData();
        }
      },
    },
    selectedNode: {
      immediate: true,
      handler(node) {
        if (isEqual(this.treeType, 'physical')) {
          const objdefineList = MANAGETYPE_OBJDEFINE[node.managetypeId];
          this.$store.dispatch('setObjDefineIds', objdefineList);
        }
      },
    },
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/group/index.vue